<template>
  <ConfirmModal
    class="is-default-theme"
    :confirm-fn="confirmFn"
    :cancel-fn="cancelFn"
    :is-primary-button-disabled="isPrimaryButtonDisabled"
    :is-scrollable="false"
    :primary-button-text="$t('estate.submit')"
    :cancel-button-text="$t('core.cancel')"
  >
    <template #body>
      <section class="has-text-centered is-size-5">
        <p class="is-size-3 has-text-weight-semibold">
          {{ $t('ai.how-we-can') }}
          <span v-if="feedbackToEdit.isPositive || isDescriptionOptional">
            ({{ $t('auth.optional') }})
          </span>
        </p>
        <p class="m-t-10">
          {{ $t('ai.your-feedback-helps') }}
        </p>
        <div class="m-t-20 m-b-20">
          <FormTextarea
            v-model="feedbackToEdit.description"
            type="text"
            rows="3"
            :placeholder="$t('ai.describe-what-was')"
          />
        </div>
      </section>
    </template>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '/@/modules/core/ui/components/ConfirmModal.vue';
import { EstateRagFeedbackObject } from '@/modules/ai/models/EstateRagFeedbackObject';
import FormTextarea from '@/modules/core/form/components/FormTextarea.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraFeedbackConfirmModal',
  components: { FormTextarea, ConfirmModal },
  props: {
    feedback: {
      type: EstateRagFeedbackObject,
      required: true
    },
    confirmFn: {
      type: Function,
      required: true
    },
    cancelFn: {
      type: Function,
      required: true
    },
    isDescriptionOptional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    feedbackToEdit() {
      return this.feedback;
    },
    isPrimaryButtonDisabled() {
      if (this.isDescriptionOptional) {
        return false;
      }

      return !this.feedbackToEdit.isPositive && !this.feedbackToEdit.description;
    }
  }
};
</script>
